import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { Row, Col, Card, Button, ListGroup, ListGroupItem, Modal, Badge } from "react-bootstrap";
import { Progress } from 'shards-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import AddSubscription from './AddSubscription';
import {
  userActions,
  subscriptionActions,
} from '../../actions';
import { useFormik } from 'formik';
import moment from 'moment-jalaali'
import AuthImage from "../common/AuthImage";

const UserDetails = ({ user }) => {
  const dispatch = useDispatch();
  const subscription = useSelector(state => state.subscription.currentSubscription);
  const remainSub = useSelector(state => state.subscription.subRemainedDays);
  const [show, setShow] = useState(false);
  const [sub, setSub] = useState();
  const userId = _.get(user, '_id');

  useEffect(() => {
    if (!user) return;
    dispatch(subscriptionActions.resetState());
    dispatch(subscriptionActions.getUserSubscription(user._id));
  }, [user, dispatch])

  useEffect(() => {
    if (!subscription) {
      setSub(null);
      return;
    }

    const periodDays = moment(_.get(subscription, 'currentPeriodEnd', 0)).diff(moment(_.get(subscription, 'currentPeriodStart', 0)), 'days', true);
    const plan = `${_.get(subscription, 'plan.intervalCount')} ${_.startCase(_.get(subscription, 'plan.interval'))}`
    const rawPercent = periodDays > 0 ? (remainSub * 100 / periodDays) : 0;
    const percent = Math.max(0, Math.min(100, Math.round(rawPercent)));
    setSub({ days: periodDays, plan: plan, percent: percent })
  }, [subscription, remainSub])

  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => {
    setShow(false);
    formik.resetForm();
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId: _.get(user, '_id', ''),
      status: _.get(user, 'status', ''),
      verified: _.get(user, 'verified', ''),
      password: '',
      loginFailed: _.get(user, 'loginFailed', ''),
      role: _.get(user, 'role', ''),
      group: _.get(user, 'group', ''),
    },
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      const payload = { ...values };
      if (!payload.password) delete payload.password;
      if (!payload.group) delete payload.group;
      if (payload.status) {
        payload.verified = true;
        payload.loginFailed = 0;
      }
      setStatus(null);
      try {
        await dispatch(userActions.update(payload));
        handleClose();
      } catch (error) {
        setStatus((error && (error.error || error.message)) || 'Unable to update account');
      } finally {
        setSubmitting(false);
      }
    },

  });
  const accountProps = (user) => {
    let status;
    let role = <Badge variant="primary">{_.startCase(_.get(user, 'role'))}</Badge>;
    const groupValue = _.get(user, 'group');
    const groupLabel = groupValue === 'vibino' ? 'Monda' : _.startCase(groupValue);
    let group = groupLabel ? <Badge variant="primary">{groupLabel}</Badge> : null;
    let verified = _.get(user, 'verified') ? <Badge variant="success">Verified</Badge> : <Badge variant="warning">Not Verified</Badge>;
    switch (_.get(user, 'status')) {
      case 'active':
        status = <Badge variant="success">Active</Badge>
        break;
      case 'waiting':
        status = <Badge variant="warning">Waiting</Badge>
        break;
      case 'block':
        status = <Badge variant="danger">{`Block (${_.get(user, 'loginFailed')} Login Failed)`}</Badge>
        break;
      default:
        break;
    }
    return (
      <div className="badgeBox">
        {verified}{status}{role}{group}
      </div>
    )
  }

  return (
    <>
      <Card className="mb-4 pt-3">
        <Card.Header className="border-bottom text-center">
          <Row>
            <Col>
              <h5 className="mb-0">{`${_.get(user, 'username', '')}`.trim()} </h5>
              {accountProps(user)}
              <AuthImage
                className="rounded-circle"
                src={userId ? `${process.env.REACT_APP_FILE_SERVER}/users/${userId}/avatar.png` : ''}
                alt={`${_.get(user, 'details.firstname', '')} ${_.get(
                  user,
                  'details.lastname',
                  '',
                )}`.trim()}
                width="100"
                style={{ margin: '10px auto' }}
              />
              <br />
              <Button variant="outline-primary" size="sm" className="mb-2 rounded-pill" onClick={handleShow}>
                <i className="material-icons mr-1">edit</i> Edit Account
            </Button>
            </Col>
            {/* <Col>
              <Row>
                <span className="text-muted d-block mb-2">Role:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'role', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Verified:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'verified', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Status: </span>{userStatus(_.get(user, 'status'))}
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Login Failed:</span>
                <span className="text-muted d-block mb-2">{_.get(user, 'loginFailed', '')}</span>
              </Row>
              <Row>
                <span className="text-muted d-block mb-2">Passwoed:</span>
                <span className="text-muted d-block mb-2">********</span>
              </Row>

            </Col> */}
          </Row>
          <Row>


          </Row>
          {/* <div className="mb-3 mx-auto">
        </div> */}
        </Card.Header>
        <ListGroup variant="flush">
          <ListGroupItem className="px-4">
            <div className="progress-wrapper">
              <strong className="text-muted d-block mb-2">
                {_.get(sub, 'days') ? `${remainSub}/${Math.round(sub.days)}` : 'No active plan'}
              </strong>
              <Progress
                className="progress-sm"
                value={_.get(sub, 'percent', 0)}
              >
                <span className="progress-value">
                  {_.get(sub, 'percent', 0)}%
            </span>
              </Progress>
            </div>
          </ListGroupItem>
          <ListGroupItem>
            <AddSubscription userId={_.get(user, '_id')} />
          </ListGroupItem>
          {/* <ListGroupItem className="p-4">
            <strong className="text-muted d-block mb-2">
              {_.get(user, 'metaTitle', 'Account')}
            </strong>
            <span>{_.get(user, 'metaValue', '50')}</span>
          </ListGroupItem> */}
        </ListGroup>
      </Card>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Account</Modal.Title>
        </Modal.Header>
        <form id="form" onSubmit={formik.handleSubmit}>
          <Modal.Body>
            {formik.status && <div className="alert alert-danger">{formik.status}</div>}
            <Row>
              <Col>
                <span>Role:</span>
                <select id="role" name="role" value={formik.values.role} onChange={formik.handleChange}>
                  <option value='client' >Client</option>
                  <option value='operator' >Operator</option>
                  <option value='admin' >Admin</option>
                </select>
              </Col>
              {formik.values.role === "operator" && (
                <Col>
                  <span>Group:</span>
                  <select id="group" name="group" value={formik.values.group} onChange={formik.handleChange}>
                    <option value='' ></option>
                    <option value='vibino' >Monda</option>
                    <option value='bdok' >Bdok</option>
                  </select>
                </Col>
              )
              }
              <Col>
                <span>Status:</span>
                <select id="status" name="status" value={formik.values.status} onChange={formik.handleChange}>
                  <option value="active" >Active</option>
                  <option disabled hidden value="waiting" >Waiting</option>
                  <option value="block" >Block</option>
                </select>
              </Col>
            </Row>
            <Row>
              <Col>
                <span>Password:</span>
                <input type="password" id="password" name="password" value={formik.values.password} onChange={formik.handleChange} />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" variant="danger" onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="primary" disabled={formik.isSubmitting}>
              {formik.isSubmitting ? 'Updating...' : 'Update'}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

UserDetails.propTypes = {
  user: PropTypes.object.isRequired
};

export default UserDetails;
